import ErrorStatus from '$shared/constants/ErrorStatus';
import Label from '$provider/constants/Label';
import UIErrorMessage from '$shared/constants/UIErrorMessage';
import { formatString } from '$shared/helpers/utils';
import { ErrorMessage } from '$shared/models/ErrorMessage';
import type { ErrorStatusMapping } from '.';

class SchemaError {
  public getSchema(): ErrorStatusMapping {
    return {
      [ErrorStatus.BadRequest]: ErrorMessage.create(
        formatString(UIErrorMessage.FailedToGetInfo, Label.Schema),
        true
      ),
      [ErrorStatus.Forbidden]: ErrorMessage.create(
        formatString(UIErrorMessage.PermissionMissingToGetInfo, Label.Schema),
        true
      )
    };
  }
}

export const schemaError = new SchemaError();
